import {
  GreyGrey90,
  Image,
  Primary13Regular,
  Box,
  Flex
} from '@sequencehq/core-components'
import quickbooksCover from './quickbooksCover.png'

export const QuickBooksIntegrationDetail = () => {
  return (
    <Flex flexDirection="column" gap="20px">
      <Image
        src={quickbooksCover}
        width="100%"
        borderRadius="8px"
        draggable={false}
      />
      <Box {...Primary13Regular} color={GreyGrey90} lineHeight="18px">
        Integrate Sequence with QuickBooks Online to automate your invoicing and
        accounting. Import customers directly from QuickBooks to streamline
        onboarding. Finalized invoices and credit notes in Sequence are
        seamlessly updated in QuickBooks, reducing manual data entry and better
        accuracy.
      </Box>
    </Flex>
  )
}
